import { adminConstants } from "../constant/admin-constant";

const initialState = {};

export function customerReducer(state = initialState, action) {
    switch (action.type) {
        case adminConstants.DELETE_CUSTOMER_SUCCESS:
            return {
                ...state,
                customersData: [
                    ...state.customersData.filter(
                        item => item.id !== action.payload
                    )
                ]
            };
        case adminConstants.STORE_CUSTOMER_REQUEST:
            return { ...state, loading: true };
        case adminConstants.STORE_CUSTOMER_SUCCESS:
            return {
                ...state,
                loading: false,
                customer: action.payload.customer
            };
        case adminConstants.STORE_CUSTOMER_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.PAGINATION_CUSTOMERS_REQUEST:
            return { ...state, loading: true };
        case adminConstants.PAGINATION_CUSTOMERS_SUCCESS:
            return {
                ...state,
                customersData: action.payload.customers.data,
                pages: action.payload.customers.last_page,
                loading: false,
                current_page: action.payload.customers.current_page
            };
        case adminConstants.CUSTOMERS_DROPDOWN_LIST_SUCCESS:
            return {
                ...state,
                customersData: action.payload.customers
            };
        case adminConstants.PAGINATION_CUSTOMERS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case adminConstants.PAGINATION_CUST_ADDRESSES_SUCCESS:
            return {
                ...state,
                customersAddressData: action.payload.data,
                pages: action.payload.last_page,
                loading: false,
                current_page: action.payload.current_page
            };
        case adminConstants.GET_ADDRESS_ITEM_SUCCESS:
            return { ...state, loading: false, addressItem: action.payload };
        case adminConstants.DELETE_ADDRESS_ITEM_SUCCESS:
            return {
                ...state,
                customersAddressData: [
                    ...state.customersAddressData.filter(
                        item => item.id !== action.payload
                    )
                ]
            };
        case adminConstants.GET_CONTACT_SUCCESS:
            return { ...state, loading: false, contactItem: action.payload.result.contact };
        case adminConstants.GET_CUSTOMER_SUCCESS:
            return {
                ...state,
                customer: action.payload.result.data
            };
        case adminConstants.PAGINATION_CUST_CONTACTS_SUCCESS:
            return {
                ...state,
                contactsData: action.payload,
                pages: action.payload.last_page,
                loading: false,
                current_page: action.payload.current_page
            };
        case adminConstants.GET_LOGGED_IN_CUSTOMER_CONTACTS:
            return {
                ...state,
                contactsData: action.payload.contacts
            };
        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/CustomerReducer.jsx